module.exports = __webpack_public_path__ + "img/云存储4.3a5ef98d.jpg";